import Vue from 'vue';
import App from './App';
import api from 'api';
import '@/config/loader';

import { 
    Message,
} from 'element-ui';

import 'style/common.scss';

Vue.prototype.$api = api;
Vue.prototype.$message = Message;

new Vue({
    render: h => h(App)
}).$mount('#app')